import { createTestIds } from '../../utils';

export const getMenuTestIds = createTestIds('menu', ['create-new'] as const);

export const getMenuItemTestIds = createTestIds('menu-item', [] as const);
